import { Paper, Title } from '@mantine/core';

const MassIntentions = () => {
  return (
    <Paper p="xl" radius="md" w="100%">
      <Title order={3}>Mass Intentions</Title>
      <p>Mass Intentions content will be implemented here.</p>
    </Paper>
  );
};

export default MassIntentions;
